import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [authed, setAuthed] = useState(false);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      await axios.get(`${API}/admin/me`, { withCredentials: true });
      setAuthed(true);
    } catch {
      setAuthed(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = useCallback(async (password) => {
    await axios.post(
      `${API}/admin/login`,
      { password },
      { withCredentials: true }
    );
    setAuthed(true);
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/admin/logout`, {}, { withCredentials: true });
    } catch {
      /* ignore */
    }
    setAuthed(false);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ authed, loading, login, logout, check }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
  return ctx;
}
